import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, takeUntil, withLatestFrom } from 'rxjs';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { Select, ofActionSuccessful } from '@ngxs/store';

import { NgxsActionName, NgxsFormPath } from '@app/shared/constants';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import * as AppDataAction from '@app/shared/actions/app-data.action';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import { InjectDialogData } from '@shared/components/edit-modal-dialog/edit-modal-dialog.constant';
import { WebApiResponseBase } from '@app/shared/classes/general';
import { EditModalDialogBasedComponent } from '@shared/components/edit-modal-dialog/edit-modal-dialog.based.component';
import { KpiEconomy } from '@app/shared/classes/kpi-economy';
import { KPINameNameIdMapping } from '@app/shared/enums';

@Component({
  selector: 'app-economy-edit-modal-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SpinnerButtonComponent, TranslateModule, NgxsFormPluginModule, ReactiveFormsModule, MatDialogModule, AngularMaterialModule],
  templateUrl: './economy-edit-modal-dialog.component.html',
  styleUrl: './economy-edit-modal-dialog.component.css'
})
export class EconomyEditModalDialogComponent extends EditModalDialogBasedComponent<EconomyEditModalDialogComponent, KpiEconomy> {
  formPath = NgxsFormPath.KPI_ECONOMY_EDIT_FORM;
  showValueEdit = true;
  uom = "";

  @Select(AppDataState.taskExecuting(NgxsActionName.UPDATE_KPI_ECONOMY)) updating$: Observable<boolean>;
  @Select(AppDataState.taskError(NgxsActionName.UPDATE_KPI_ECONOMY)) response$: Observable<WebApiResponseBase>;

  constructor(public dialogRef: MatDialogRef<EconomyEditModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InjectDialogData<KpiEconomy>) {
    super();
    this.dataInit(dialogRef, data);
    this.initForm(data);
  }

  initForm = (data: InjectDialogData<KpiEconomy>) => {
    this.uom = data.data.kpiUom;
    if (data.data.kpi.kpiId !== KPINameNameIdMapping.FUEL_CONSUMPTION_RATE && data.data.kpi.kpiId !== KPINameNameIdMapping.ECONOMY_ENGINE_SPEED_RATE) {
      this.showValueEdit = false;
      this.editForm = this.formBuilder.group({
        kpiScore: [data.data.score, Validators.required],
      });
    }
    else {
      this.editForm = this.formBuilder.group({
        kpiValue: [data.data.kpiValue, Validators.required]
      });
    }
  }

  override  ngOnInit() {
    super.ngOnInit();
    this.actions$.pipe(ofActionSuccessful(AppDataAction.UpdateKpiEconomy), withLatestFrom(this.response$), takeUntil(this.destroy$)).subscribe(
      ([_, errorResponse]) => this.processAfterUpdateObject(errorResponse));
  }

  onOkClick = () => {
    this.store.dispatch(new AppDataAction.UpdateKpiEconomy(this.data.data));
  }
}
